import { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuth } from '../../contexts/AuthContext';
import { setOrkaTokenGetter } from './api';
import NodesView from './NodesView';
import VMsView from './VMsView';
import ImagesView from './ImagesView';
import PoolView from './PoolView';
import './Orka.css';

const TABS = [
  { key: 'nodes', label: 'Nodes' },
  { key: 'vms', label: 'Virtual Machines' },
  { key: 'images', label: 'Images' },
  { key: 'pool', label: 'Cache Pool' },
];

function OrkaDashboard({ onBack, activeTab: activeTabProp, onTabChange }) {
  // Controlled by the route when activeTab/onTabChange are provided; otherwise
  // falls back to internal state (e.g. standalone rendering / tests).
  const [internalTab, setInternalTab] = useState('nodes');
  const activeTab = activeTabProp || internalTab;
  const selectTab = (key) => (onTabChange ? onTabChange(key) : setInternalTab(key));
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: { queries: { refetchOnWindowFocus: false, retry: 1 } },
  }));
  const { getToken } = useAuth();

  // Attach the app's Firebase token to every Orka API request.
  useEffect(() => {
    setOrkaTokenGetter(getToken);
  }, [getToken]);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="orka-dashboard">
        <div className="header">
          <div>
            <h1>Orka Dashboard</h1>
            <p>Manage your Orka infrastructure and Harbor images</p>
          </div>
          {onBack && (
            <button className="btn btn-secondary" onClick={onBack}>{'<-'} Back</button>
          )}
        </div>

        <div className="tabs">
          {TABS.map(({ key, label }) => (
            <button
              key={key}
              className={`tab ${activeTab === key ? 'active' : ''}`}
              onClick={() => selectTab(key)}
            >
              {label}
            </button>
          ))}
        </div>

        <main>
          {activeTab === 'nodes' && <NodesView />}
          {activeTab === 'vms' && <VMsView />}
          {activeTab === 'images' && <ImagesView />}
          {activeTab === 'pool' && <PoolView />}
        </main>
      </div>
    </QueryClientProvider>
  );
}

export default OrkaDashboard;
